import { Col, Row } from 'antd';
import React from 'react';
import { useStyle } from "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Loading = function Loading(props) {
  var style = props.style,
    prefix = props.prefix;
  var _useStyle = useStyle(prefix || 'ant-pro-card'),
    wrapSSR = _useStyle.wrapSSR;
  return wrapSSR( /*#__PURE__*/_jsxs("div", {
    className: "".concat(prefix, "-loading-content"),
    style: style,
    children: [/*#__PURE__*/_jsx(Row, {
      gutter: 8,
      children: /*#__PURE__*/_jsx(Col, {
        span: 22,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })
    }), /*#__PURE__*/_jsxs(Row, {
      gutter: 8,
      children: [/*#__PURE__*/_jsx(Col, {
        span: 8,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 15,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })]
    }), /*#__PURE__*/_jsxs(Row, {
      gutter: 8,
      children: [/*#__PURE__*/_jsx(Col, {
        span: 6,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 18,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })]
    }), /*#__PURE__*/_jsxs(Row, {
      gutter: 8,
      children: [/*#__PURE__*/_jsx(Col, {
        span: 13,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 9,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })]
    }), /*#__PURE__*/_jsxs(Row, {
      gutter: 8,
      children: [/*#__PURE__*/_jsx(Col, {
        span: 4,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 3,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 16,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefix, "-loading-block")
        })
      })]
    })]
  }));
};
export default Loading;